import React from 'react';
import { AppState } from '@om-fe/core/core/types';
import { connect } from 'react-redux';
import Anchor from '@om-fe/core/components/anchor/anchor';
import { bemSlider } from '@om-fe/widgets/dist/components/slider/slider.constants';
import getSlice from '@om-fe/core/utils/get-slice';
import { BemModifier } from '@om-fe/utils';
import { ParamModel } from '@om-fe/core/core/routing/utils';
import { TimeRangeListItemModel, TimeRangeListStateModel } from './time-range-nav.reducer';
import { getTopBetsTimeRangeSliceName } from '../../utils/top-bets.utils';
import { TimeRangeType } from '../../utils/top-bets.constants';

interface TimeRangeNavItemPublicProps {
    readonly id: string;
    readonly instanceId: string;
    readonly activeTab?: string;
    readonly preventRedirect?: boolean;
    readonly noRedirectFilter?: (genericId?: string) => void;
    readonly genericId?: string;
    readonly extraClassName?: string;
}

export interface RouteParams {
    readonly disciplineId: string;
    readonly disciplineName: string;
    readonly locationId?: string;
    readonly locationName?: string;
    readonly sportLocationId?: string;
    readonly sportLocationName?: string;
    readonly tournamentId: string;
    readonly tournamentName: string;
    readonly eventCategoryId: string;
    readonly eventCategoryName: string;
}

interface TimeRangeItemProps {
    readonly item?: TimeRangeListItemModel;
}

type TimeRangeNavItemProps = TimeRangeItemProps &  TimeRangeNavItemPublicProps;

function TimeRangeNavItemComponent (
    {
        id,
        item,
        preventRedirect,
        noRedirectFilter,
        activeTab,
    }: TimeRangeNavItemProps) {
        let pathParams: ParamModel;

        pathParams = {
            activeTab,
        };

        if (!item) {
            return null;
        }

        return (
            <Anchor
                extraClassName={bemSlider({
                    element: 'Action',
                    modifier: {
                        'Live': item.timeRangeType === TimeRangeType.LIVE
                    }
                })}
                activeClassName={BemModifier.Active}
                routeName={pathParams}
                isActive={activeTab === id}
                preventRedirect={preventRedirect}
                handleClickAnchor={() => preventRedirect && noRedirectFilter ? noRedirectFilter(id) : null }
            >
                <div className={bemSlider('ItemIcon')}></div>
                <div className={bemSlider('ItemText')}>
                    {item.displayName}
                </div>
            </Anchor>
        );
    };

const TimeRangeNavItem: React.ComponentType<TimeRangeNavItemPublicProps> = connect(
    (state: AppState, { id, instanceId }: TimeRangeNavItemPublicProps): TimeRangeItemProps => {
        const sliceName: string = getTopBetsTimeRangeSliceName(instanceId);
        const slice: TimeRangeListStateModel | undefined = getSlice<TimeRangeListStateModel>(state, sliceName);

        if (!slice) {
            return {};
        }

        return ({
            item: slice.items[id],
        });
    },
)(TimeRangeNavItemComponent);
export default TimeRangeNavItem;